module.exports = __webpack_public_path__ + "static/media/conoce-tu-factura.6946b610.jpg";